import mongoose from 'mongoose';
import { isDev, mongoURL } from './environment';
import errorWithCode from './error-with-code';
import { getLoggerInstance } from './logger';

const logger = getLoggerInstance();

export const defaultOptions: mongoose.ConnectionOptions = { poolSize: 1 };

/**
 * Checks if connection is already active or not
 * If connection is already active does not try to initiate a new connection
 * @param {import('mongoose').ConnectionOptions} options
 */
export async function connect(options: mongoose.ConnectionOptions = {}) {
  if (!mongoURL) {
    throw errorWithCode(500, 'MONGO_URL env var not passed');
  }
  logger.trace('db.connect()');
  const { readyState } = mongoose.connection;
  if (!readyState) {
    mongoose.set('debug', isDev);
    return mongoose
      .connect(mongoURL, { useNewUrlParser: true, ...defaultOptions, ...options })
      .then(db => {
        logger.trace('connected to db');
        return db;
      })
      .catch(error => logger.error({ error }, 'db connection failed'));
  }
  logger.trace('db cached connection');
  return undefined;
}

export async function disconnect() {
  return mongoose.disconnect();
}
